import StorefrontIcon from '@material-ui/icons/Storefront';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

// The marketplace lays out its own content: the home view has no header and
// the detail view renders a core-components Header, so the framework header is
// off. Moving to the framework/BUI header belongs to the MUI→BUI track.
// Pages are mounted at `<path>/*`, so the page's own <Routes> still serves the
// `/:namespace/:name` detail view.
const aiMarketplacePage = PageBlueprint.make({
  params: {
    path: '/ai-marketplace',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AIMarketplacePage/AIMarketplacePage').then(m => (
        <m.AIMarketplacePage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'ai-marketplace',
  title: 'AI Marketplace',
  icon: <StorefrontIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  routes: { root: rootRouteRef },
  extensions: [aiMarketplacePage],
});
